import SimpleBar from 'simplebar';
import whenDomReady from 'when-dom-ready';

function initialise() {
  const scrollableElements = Array.from(document.querySelectorAll('.js-scrollbar'));
  scrollableElements.forEach(el => new SimpleBar(el));
}

whenDomReady().then(initialise);
